import ComingSoon from '../../../../ComingSoon'

const ActivityLog = () => {
  return (
    <div className="relative flex flex-col flex-1 w-full gap-4 bg-white">
      <div className="flex flex-col flex-1">
        <div className="flex flex-1 gap-4">
          <div className="flex flex-1 h-[600px]">
            <div className="w-full h-full gap-5">
              <div className="flex items-center justify-between mt-2.5 mb-0.5">
                <h4 className="font-bold text-teal-300 text-xs-display">
                 Activity Log
                </h4>
              </div>
              <div className="border-b-[7px] border-gray-20 mb-[20px]"></div>
              <div className="w-full relative min-w-[400px]">
                <ComingSoon />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivityLog;